import { AccordionDesignTokens } from '@primeuix/themes/types/accordion';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/accordion/index.ts
const acc = componentCommon.accordion;

export const AccordionTelekomDT: AccordionDesignTokens = {
  header: {
    color: t(acc.header.color),
    activeColor: t(acc.header.active.color),
    background: 'transparent',
    activeBackground: 'transparent',
    hoverBackground: t(acc.header.hover.background),
    activeHoverBackground: t(acc.header.active.hover.background),
  },
  content: {
    background: 'transparent',
  },
  panel: {
    borderWidth: '0',
  },
};
